import 'vite/modulepreload-polyfill';

//https://github.com/fontsource/fontsource
import "@fontsource/roboto";

import "../Scss/styles.scss";
import "../Scss/fontawesome.scss";

import "./modules/CookieConsent";
import "./modules/Autocomplete";
import "./modules/AutocompleteMobile";
import "./modules/NavBannerReplacemen";

import {
  Tooltip,
  Collapse,
  Dropdown,
  Alert,
  Tab,
  ScrollSpy,
} from "bootstrap";

if (import.meta.hot) {
  import.meta.hot.accept();
}

// document.addEventListener('DOMContentLoaded', () => {
// document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(element => {
//   Tooltip.getOrCreateInstance(element);
// });
// document.querySelectorAll('.collapse').forEach(element => {
//   Collapse.getOrCreateInstance(element);
// });
// document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(element => {
//   Dropdown.getOrCreateInstance(element);
// });
// document.querySelectorAll('[data-bs-toggle="tab"]').forEach(element => {
//   Tab.getOrCreateInstance(element);
// });
// document.querySelectorAll('[data-bs-spy="scroll"]').forEach(element => {
//   Scrollspy.getOrCreateInstance(element);
// });
// document.querySelectorAll('.alert').forEach(element => {
//   Alert.getOrCreateInstance(element);
// });
// });

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.glightbox');
  if (items.length > 0) {
    import("./modules/lightbox" /* webpackChunkName: "glightbox" */).then(({default: init}) => {
      init();
    })
  }

  // https://github.com/ganlanyuan/tiny-slider
  const sliders = document.querySelectorAll('.tiny-slider');
  if (sliders.length) {
    import("./modules/tiny-slider" /* webpackChunkName: "tiny-slider" */).then(({default: initSlider}) => {
      initSlider(sliders);
    })
  }
});

// wait for the vitejs backend to reload correctly after vite.config.js or package.json changes
if (process.env.NODE_ENV !== "production") {
  let retries = 5;
  const {fetch: originalFetch} = window;

  window.fetch = async (...args) => {
    let [resource] = args;
    if (resource.includes(`:${import.meta.env.VITE_DEV_PORT ?? 5173}`)) {
      try {
        const response = await originalFetch(...args);
        if (!response.ok) {
          if (retries > 0) {
            retries--;
            await new Promise(resolve => setTimeout(resolve, 1000));
            return await originalFetch(...args);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    return await originalFetch(...args);
  };
}


document.querySelectorAll('.short-text').forEach(function (element) {
  const maxLength = 300;
  const originalText = element.textContent;

  if (originalText.length > maxLength) {
    element.textContent = originalText.slice(0, maxLength) + "...";
  }
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.schauburg-schedule-list-filter-reset-button')?.addEventListener('click', function (event) {
    event.preventDefault()
    const form = this.form;
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
      if('tx_moviemanagement_movieplan[date]' === select.name) {
        select.options[1].setAttribute('selected', 'selected')
      } else {
        disableSelectedOptions(select.options)
      }
    });
    form.submit();
  });
});

/**
 *
 * @param {HTMLOptionsCollection} options
 */
function disableSelectedOptions(options) {
  Array.from(options).forEach(option => {
    option.removeAttribute('selected')
  })
  return options;
}

document.addEventListener('DOMContentLoaded', function () {
  const searchButton = document.getElementById('menu-form');
  const searchInput = document.getElementById('form_kesearch_pi1');

  searchButton.addEventListener('click', function (event) {
    searchInput.classList.toggle('d-none');
    searchButton.classList.toggle('d-none');
  });

  document.addEventListener('click', function (event) {
    if (!searchButton.contains(event.target) && !searchInput.contains(event.target)) {
      if (!searchInput.classList.contains('d-none')) {
        searchInput.classList.add('d-none');
      }
      if (searchButton.classList.contains('d-none')) {
        searchButton.classList.remove('d-none');
      }
    }
  });
});

